import React from 'react';
// import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { translate } from 'react-i18next';
import BaseLayout from '../../components/Layout/BaseLayout';
// import { myIsSet } from '@tickled-media/web-components.tm-helpers';
import { makeRoute } from '../../helpers';

const SmhArticleList = (props) => {
    const { t, sitemapArticles, appReducer } = props;
    const sitemap_topics = sitemapArticles && sitemapArticles.sitemap_topics ? sitemapArticles.sitemap_topics : {};
    const { current_page = null, data = [], year = '', month = '', to = null, total = null } = sitemap_topics;
    // to: article list per page, total: total article list 

	return (
		<div className={`smh-article-list`}>
           <h1 className={`article-list-head`}>{`${t('sitemap_theAsianparent')} ${t('sitemap_articles_for_year')}`} <Month month={month} t={t} /> {year}</h1>
            {
                data && data.length === 0 &&
                <div className={`loader`}>
                    <span className={`spinner`} />
                </div>
            }
            {
                data && data.length > 0 &&
                <div className={`sitemap-entries`}>
                    <ul>
                        <li>
                            <span>{t('sitemap_date')}</span>
                            <span className={'article-title'}>{t('sitemap_title')}</span>
                        </li>
                        {
                            data.map( (article,index) => {
                                /* code for spliting date and time - start */
                                const str = article.created_at;
                                const res = str.split(' ');
                                /* code for spliting date and time - end */

                                return(
                                    <li key={index}>
                                        <span className={`date`}>
                                            {res[0]}
                                        </span>
                                        <a href={article.url}>{article.title}</a>
                                    </li>
                                )
                            })
                        }
                    </ul>
                    {
                        // match total article list for next page data
                        to !== total &&  
                        <a className={`load-more`} href={makeRoute(`${props.match.url}?page=${current_page + 1}`, appReducer)}>{t('sitemap_load_more')}</a>
                    }
                </div>
            }
        </div>
	)
}

const Month = (props) => {
    const { month, t } = props;
    let months = "";

    const monthNames = [`${t("sitemap_january")}`, `${t("sitemap_february")}`, `${t("sitemap_march")}`, `${t("sitemap_april")}`, `${t("sitemap_may")}`, `${t("sitemap_june")}`, `${t("sitemap_july")}`, `${t("sitemap_august")}`, `${t("sitemap_september")}`, `${t("sitemap_october")}`, `${t("sitemap_november")}`, `${t("sitemap_december")}`];
    months = monthNames[month - 1];

    return(
        <span>{months}</span>
    )
}

const YearMonthWeekList = (props) => {
    const { t, sitemapWeeks, appReducer } = props;

    return (
    	<div className={`years-month-list`}>
            <h1>{`${t('sitemap_theAsianparent')} ${t('sitemap_articles_for_year')} ${props.year}`}</h1>

            <ul className={`sitemap-month`}>
                {
                    sitemapWeeks && sitemapWeeks.length > 0 &&
                    sitemapWeeks.map((item, key) => {
                       return  (
                           <li key={key}>
                                <div className={`sub-title`}>
                                      {t('sitemap_articles_for_year')} <Month month={item.month} t={t} /> {props.year}
                                </div>
                                <div className={'sitemap-week'}>
                                    {
                                        item.weeks && item.weeks.length > 0 &&
                                        item.weeks.map((week, key) => {
                                            return(
                                                <a key={key} href={makeRoute(`/sitemap/article/${props.year}/${week.week}`, appReducer)}>
                                                    {t('sitemap_week')} {week.week}
                                                </a>
                                            )
                                        })
                                    }
                                </div>
                           </li>
                       )
                    })
                }
            </ul>
        </div>
    )
}

const YearList = (props) => {
    const { t, sitemapYears, appReducer } = props;
    return (
        <div className={`sitemap-year`}>
            <h1>{`${t('sitemap_theAsianparent')} ${t('sitemap_main_index')}`}</h1>

            <div className={`sub-title`}>
                {t('sitemap_article_by_year')}
            </div>

            <div className={'year-list'}>
               {
                    sitemapYears && sitemapYears.length > 0 &&
                    sitemapYears.map((item, key) => {
  					   return  (
                            <a key={key} href={makeRoute(`/sitemap/article/${item.year}`, appReducer)}>{item.year}</a>
  				       )
  					})
               }
            </div>
        </div>
    )
}

const SitemapHtml = (props) => {
        const { sitemapYears = [], sitemapWeeks = [], sitemapArticles = [] } = props.sitemapReducer;

		const t = props.t,
        year = props.match.params.year || '';

        return (
            <BaseLayout history={props.history} match={props.match}>
                <div className={`sitemap-html`}>
                	{
                		props.match.path === "/sitemap/:slug/:year/:week" &&
                		<SmhArticleList
                            appReducer={props.appReducer} 
                			sitemapArticles={sitemapArticles}
                            match={props.match}
                            t={t}
                		/>
                	}
                	{
                		props.match.path === "/sitemap/:slug/:year" &&
                		<YearMonthWeekList 
                            appReducer={props.appReducer}
                			sitemapWeeks={sitemapWeeks} 
                			year={year}
                            t={t}
                		/>
                	}
                    {
                    	((props.match.path === "/sitemap/:slug" && props.match.params.slug === 'article') || props.match.path === "/sitemap") &&
                    	<YearList 
                            appReducer={props.appReducer}
                    		sitemapYears={sitemapYears}
                            t={t}
                    	/>
                    }
                </div>
            </BaseLayout>
        );
}

// map state
const mapStateToProps = (state) => state;

export default connect(mapStateToProps)(translate()(SitemapHtml));